
import { Grid, Typography, Paper, Box } from '@mui/material'
import React, { useEffect } from 'react'
import WellnessScore from '../WellnessScore'
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import RYGGHorizontalBar from '../adminreport/RYGGHorizontalBar'
import { errormessagesClear, selectErrorMessagesByKeyName, selectErrorMessagesByNegativeCode } from '../../../reducers/reference_errormessages'
import { useSelector } from 'react-redux'
/** 
 * 
 * This component is expecting the following input. 

{
    "Order": "10",
    "Visible": "1",
    "Label": "",
    "ComponentType": "OWS AND HEALTH AGE",
    "OWS": {
        "Visible": "1",
        "Label": "Your Overall Wellness Score",
        "Value": "45",
        "ValueGrade": "2"
    },
    "HealthAge": {
        "CurrentLabel": "Health Age",
        "CurrentValue": "19.9",
        "AchievableLabel": "Achievable Health Age",
        "AchievableValue": "17.5"
    }
},
*/


const AdminErrorMessage = (props) => {
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }
    const Component = props.component
    const ErrorMessage = useSelector(state=>selectErrorMessagesByNegativeCode(state,Component.ErrorID,-1))

    useEffect(()=>{},[ErrorMessage, Component])
   
    //console.log('adminfallrisk.js', props.component)
    return (
        <Grid item xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }} >
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '10px', height: '100%' }}>
                    <Grid
                        container
                        direction="row"
                        alignItems="top"
                        justifyContent="center"
                        spacing={2}
                    >
                        <Grid item xs={12} >
                               <Typography variant="body1" color="error" align="center" fontWeight={"bold"}>{ErrorMessage && ErrorMessage.length>0 && ErrorMessage[0].MessageTypeContent}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </motion.div>
        </Grid>

    )
}

export default AdminErrorMessage;